export default "__VITE_ASSET__85428d2e__"